import React, { Component } from 'react';

/**
 * Error Boundary raiz del LoginPortal (Tiger Gateway).
 * Evita pantalla en blanco si un render hijo explota tras el boot.
 */
class LoginPortalErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    const message = error instanceof Error
      ? error.message
      : 'Error inesperado en LoginPortal.';
    return { hasError: true, message };
  }

  componentDidCatch(error, info) {
    if (typeof console !== 'undefined') {
      console.error('[LoginPortal] uncaught render error', error, info?.componentStack);
    }
    try {
      document.documentElement.setAttribute('data-tiger-app-state', 'error');
    } catch {
      /* ignore */
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, message: '' });
    try {
      document.documentElement.setAttribute('data-tiger-app-state', 'loading');
    } catch {
      /* ignore */
    }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }
    return (
      <div
        role="alert"
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: 24,
          fontFamily: 'Lato, sans-serif',
          textAlign: 'center',
          color: '#28466D',
        }}
      >
        <p style={{ margin: 0, fontWeight: 700 }}>Algo salió mal en LoginPortal</p>
        <p style={{ margin: 0, maxWidth: 320 }}>
          {this.state.message || 'Reintentá cargar la pantalla de acceso.'}
        </p>
        <button
          type="button"
          onClick={this.handleRetry}
          style={{
            marginTop: 8,
            padding: '10px 16px',
            border: 0,
            borderRadius: 6,
            background: '#28466D',
            color: '#fff',
            fontSize: 14,
            cursor: 'pointer',
          }}
        >
          Reintentar
        </button>
      </div>
    );
  }
}

export default LoginPortalErrorBoundary;
